export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.2971dc542c43c1f32b20.worker.js");
}
